/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { Box, jsx } from 'theme-ui'

const Thumbnail = ({ image, handleClick, selected = false }) => {
  return (
    <Box
      sx={{
        cursor: 'pointer',
        opacity: selected ? 1 : 0.75,
        border: selected ? '1px solid' : 'none',
        borderColor: selected ? 'greyMedium' : '',
        '&:hover': {
          opacity: 1,
        },
      }}
      onClick={() => handleClick(image)}
    >
      <GatsbyImage image={image.gatsbyImageData} alt={image.description} />
    </Box>
  )
}

Thumbnail.propTypes = {
  image: PropTypes.shape({}),
  handleClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
}

export default Thumbnail
